<template>
  <v-layout row wrap>
    <v-flex lg4 md4 sm12 xs12>
      <v-container>
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h4 class="earth-color">Add Vehicle Fee</h4>
            <div class="title-decoration"></div>
          </div>
          <v-container>
            <v-form @submit.prevent="postVehicleFee()">
              <v-text-field
                label="Vehicle Category (e.g. 1 to 6)"
                v-model="vehicle_charge.category"
                :rules="requiredRules"
                required
                class="futuristic-input"
              ></v-text-field>
              <v-autocomplete
                label="Currency"
                v-model="vehicle_charge.currency"
                :items="allCurrencies"
                :rules="[v => !!v || 'Item is required']"
                required
                item-text="currency_name"
                item-value="currency_public_id"
                :loading="$loadingTrue"
                class="futuristic-input"
              ></v-autocomplete>
              <v-text-field
                label="Cost"
                v-model="vehicle_charge.cost"
                :rules="requiredRules"
                required
                min="0"
                type="number"
                class="futuristic-input"
              ></v-text-field>
              <v-text-field
                label="Maximum Number"
                v-model="vehicle_charge.max_number"
                :rules="requiredRules"
                required
                min="0"
                type="number"
                class="futuristic-input"
              ></v-text-field>
              <v-text-field
                label="Income Account Code"
                v-model="vehicle_charge.income_account_code"
                :rules="requiredRules"
                required
                class="futuristic-input"
              ></v-text-field>
              <v-text-field
                label="Department Analysis Code"
                v-model="vehicle_charge.department_analysis_code"
                :rules="requiredRules"
                required
                class="futuristic-input"
              ></v-text-field>
              <v-text-field
                label="Outlet Analysis Code"
                v-model="vehicle_charge.outlet_analysis_code"
                :rules="requiredRules"
                required
                class="futuristic-input"
              ></v-text-field>
              <v-textarea
                label="Description"
                v-model="vehicle_charge.description"
                :rules="requiredRules"
                required
                type="text"
                class="futuristic-input"
                rows="3"
              ></v-textarea>
              <v-btn 
                depressed 
                color="#587e27" 
                block 
                type="submit" 
                class="futuristic-btn rounded-btn"
                v-if="edit === false"
              >
                Add Vehicle Fee
              </v-btn>
              <v-btn 
                depressed 
                color="#ff9800" 
                block 
                type="submit" 
                class="futuristic-btn rounded-btn"
                v-if="edit === true"
              >
                Update {{vehicle_charge.category}}
              </v-btn>
            </v-form>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex lg8 md8 sm12 xs12>
      <v-container>
        <v-card flat class="futuristic-card">
          <div class="card-header">
            <h4 class="earth-color">Vehicle Fees</h4>
            <div class="title-decoration"></div>
          </div>
          <v-container class="table-container">
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
              class="futuristic-input"
            ></v-text-field>
            <v-data-table
              :headers="columns"
              :items="allVehicles"
              :search="search"
              :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
              class="futuristic-table"
            >
              <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.vehicle_charge_category}}</td>
                <td>{{ props.item.vehicle_charge_income_code}}</td>
                <td>{{ props.item.vehicle_charge_outlet_code}}</td>
                <td>{{ props.item.vehicle_charge_dept_code}}</td>
                <td>{{ props.item.vehicle_charge_cost_currency}} {{ props.item.vehicle_charge_category_cost}}</td>
                <td class="has-text-right">
                  <div class="action-buttons">
                    <v-btn 
                      depressed 
                      small 
                      color="#ff9800" 
                      @click="editVehicleFee(props.index)" 
                      class="futuristic-btn rounded-btn action-btn"
                      v-if="edit === false"
                    >
                      Edit
                    </v-btn>
                    <v-btn 
                      depressed 
                      small 
                      color="#f44336" 
                      @click="deleteVehicleFee(props.item.vehicle_charge_public_id)" 
                      class="futuristic-btn rounded-btn action-btn"
                      v-if="edit === false"
                    >
                      Disable
                    </v-btn>
                    <v-btn 
                      depressed 
                      small 
                      color="#f44336" 
                      @click="resetInputs()" 
                      class="futuristic-btn rounded-btn action-btn"
                      v-if="edit === true"
                    >
                      Cancel Edit
                    </v-btn>
                  </div>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="#f44336" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'vehicle-fees',
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      edit: false,
      search: '',
      columns: [
        {
          text: 'Vehicle Category',
          value: 'vehicle_charge_category'
        },
        {
          text: 'Income Account Code'
        },{
          text: 'Outlet Code'
        },{
          text: 'Department Code'
        },
        {
          text: 'Amount',
          value: 'vehicle_charge_category_cost'
        },
        {
          text: 'Action',
          value: ''
        }
      ],
      vehicle_charge: {
        category: '',
        cost: '',
        currency: '',
        max_number: '',
        department_analysis_code: '',
        outlet_analysis_code: '',
        income_account_code: '',
        session_id: localStorage.getItem('lkjhgfdsa'),
        charge_id: '',
        description: ''
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_currencies')
    this.$store.dispatch('get_all_vehicle_fees')
  },
  methods: {
    postVehicleFee: function () {
      var instance = this
      if (this.edit === false) {
        this.$store.dispatch('post_vehicle_fee', this.vehicle_charge).then(function () {
          instance.cancelEdit()
        })
      } else {
        this.$store.dispatch('update_vehicle_fee', this.vehicle_charge)
        // this.resetInputs()
      }
    },
    editVehicleFee: function (index) {
      this.edit = true
      var fee = this.allVehicles[index]
      this.vehicle_charge.category = fee.vehicle_charge_category
      this.vehicle_charge.cost = fee.vehicle_charge_category_cost
      this.vehicle_charge.currency = fee.vehicle_charge_cost_currency_id
      this.vehicle_charge.charge_id = fee.vehicle_charge_public_id
      this.vehicle_charge.max_number = fee.max_number
      this.vehicle_charge.department_analysis_code = fee.vehicle_charge_dept_code
      this.vehicle_charge.income_account_code = fee.vehicle_charge_income_code
      this.vehicle_charge.outlet_analysis_code = fee.vehicle_charge_outlet_code
      this.vehicle_charge.description = fee.vehicle_charge_description
    },
    deleteVehicleFee: function (publicId) {
      var data = {
        charge_id: publicId,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_vehicle_fee', data)
    },
    resetInputs: function () {
      this.edit = false
      this.vehicle_charge.category = ''
      this.vehicle_charge.currency = ''
      this.vehicle_charge.cost = ''
      this.vehicle_charge.max_number = ''
      this.vehicle_charge.charge_id = ''
      this.vehicle_charge.description = ''
      this.vehicle_charge.department_analysis_code = ''
      this.vehicle_charge.income_account_code = ''
      this.vehicle_charge.outlet_analysis_code = ''
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  height: 100%;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rounded-btn {
  border-radius: 24px !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.action-btn {
  min-width: auto;
  padding: 0 12px;
}

.table-container {
  padding: 0;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Alert styling */
.v-alert {
  border-radius: 8px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }
  
  .card-header {
    padding: 12px;
  }
  
  .earth-color {
    font-size: 1.35rem;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }
  
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
  
  .action-btn {
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>